import { withRouter } from 'react-router';
import DetailMediaRelationship from '../../components/DetailMediaPage/DetailMediaRelationship';
import { connect } from 'react-redux';
import { getMediaRelationship } from '../../graphqlDic';
import { graphql, compose } from 'react-apollo';

export default compose(
    graphql(getMediaRelationship,{
        name:'mediaRelationship',
        options: (ownProps) => ({
            variables: {
                id: ownProps.id,
                type: ownProps.type,
                limit: 8 // {0 => all}
            }
        })
    })
)(withRouter(
    connect(
        null,
        null
    )(DetailMediaRelationship)
));



// WEBPACK FOOTER //
// ./src/containers/DetailMediaPage/RelationshipMedia.js